module.exports = __webpack_public_path__ + "media/images/my_apps/vb_suite_app_icon-667fc1b80b028dc062c577a35549f214.png";